<template>
    <BaseDialog
        :showDialog="showFindDuplicatesDialog"
        maxDialogWidth="600"
        maxCardHeight="900"
        headline="lang_GENERIC_CAPTION_FIND_DUPLICATES"
        :close="closeDialog"
        persistent
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid class="py-6">
                <v-row>
                    <v-col>
                        <DropdownFilter
                            context="DuplicatesIdType"
                            label="lang_PUBLISHING_WORKS_DUPLICATES_FILTER_CAPTION_SEARCH_BY"
                            class="mx-4"
                            :items="idTypeItems"
                            :clearable="false"
                            :alvqa="alvqa + '-dropdown-id-type'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <DropdownFilter
                            context="DuplicatesScope"
                            label="lang_PUBLISHING_WORKS_DUPLICATES_FILTER_CAPTION_SHOW"
                            class="mx-4"
                            :items="scopeItems"
                            :clearable="false"
                            :alvqa="alvqa + '-dropdown-scope'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="mx-4 caption" :alvqa="alvqa + '-text-hint'">
                        {{ $t('lang_PUBLISHING_WORKS_DUPLICATES_FILTER_HINT_MAIN_FORM_STATUS') }}
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import DropdownFilter from '@/components/_filters/DropdownFilter'

export default {
    name: "FindDuplicatesDialog",
    components: {
        BaseDialog,
        DropdownFilter
    },
    data() {
        return {
            alvqa: 'publishing-works-list-dialog-find-duplicates',
        }
    },
    computed: {
        showFindDuplicatesDialog: {
            get() { return this.$store.getters.getShowFindDuplicatesDialog },
            set(show) { this.$store.commit('setShowFindDuplicatesDialog', show) }
        },
        idType() { return this.$store.getters.getSelectedDuplicatesIdType },
        idTypeItems() {
            return [
                {
                    text: this.$t('lang_PUBLISHING_WORKS_CAPTION_WORK_ID'),
                    value: 'workId',
                    alvqa: this.alvqa + '-dropdown-id-type-work-id'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_ISWC'),
                    value: 'iswc',
                    alvqa: this.alvqa + '-dropdown-id-type-iswc'
                },
                {
                    text: this.$t('lang_PUBLISHING_WORKS_DUPLICATES_FILTER_OPTION_TITLE_AND_COMPOSER'),
                    value: 'titleComposer',
                    alvqa: this.alvqa + '-dropdown-id-type-title-composer'
                },
            ]
        },
        scopeItems() {
            return [
                {
                    text: this.$t('lang_PUBLISHING_WORKS_DUPLICATES_FILTER_OPTION_WITH_STATUS_2'),
                    value: 'withStatus2',
                    alvqa: this.alvqa + '-dropdown-scope-with-status-2'
                },
                {
                    text: this.$t('lang_PUBLISHING_WORKS_DUPLICATES_FILTER_OPTION_WITHOUT_STATUS_2'),
                    value: 'withoutStatus2',
                    alvqa: this.alvqa + '-dropdown-scope-without-status-2'
                },
                {
                    text: this.$t('lang_PUBLISHING_WORKS_DUPLICATES_FILTER_OPTION_ALL'),
                    value: 'all',
                    alvqa: this.alvqa + '-dropdown-scope-all'
                },
            ]
        },
    },
    watch: {
        idType(newVal) {
            // Hardly any imported ISWC carries the status 2 marking, and neither do works that only
            // share title and composer, so that scope would look broken for them. The work id of the
            // home society on the other hand is the marked duplicate case.
            this.$store.commit('setSelectedDuplicatesScope', newVal === 'workId' ? 'withStatus2' : 'all')
        }
    },
    methods: {
        closeDialog() {
            // Every filter of the app waits for the search icon, so this one may not change the
            // sorting either: the list reacts to that change and would run the search on its own
            this.showFindDuplicatesDialog = false
        },
    }
}
</script>
